<template>
    <div id="glBalances" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="BalanceHeader" >GL Inquiry</span>
                    <!-- <button type="submit" class="btn btn-secondary pull-right " v-on:click.prevent="BackReceiptList" >
                        <i class="fp-back"> </i> Back
                    </button> -->
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="ReceiptForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                       <label class="control-label require">Account</label>
                                            <v-select v-model="gl_account_id" name="gl_account_id" id="gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                <template slot="no-options">
                                                    Search GL Account...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{account_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="processed_date">Period Month:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="processed_date" name="processed_date" v-model="processed_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="processed_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{processed_date_error_msg}}</div>
                                    </div>

                                    <div class="col-md-2">
                                        <button type="submit" v-on:click.prevent="fetchBankSummary()" class="btn btn-primary mt-4">
                                            Fetch
                                        </button>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-md-4 offset-md-8" style="float: right !important;margin-top: 50px;">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td class="bg-gray"> Opening Balance: </td>
                                                    <td class="text-right"> {{bankArr.opening}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="bg-gray"> Closing Balance: </td>
                                                    <td class="text-right"> {{bankArr.closing}} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </form>
                            <div class="purchase-order-create-main table-responsive-sm" v-if="glRows && glRows.length > 0">
                                <vue-good-table
                                    ref="listGlBalances"
                                    title="GL Balance"
                                    :columns="glColumns"
                                    :rows="glRows"
                                    max-height="600px"
                                    :pagination-options="{
                                        enabled: true,
                                        position:'top',
                                        mode: 'records',
                                        perPage: 100,
                                        perPageDropdown:[50,100],
                                        dropdownAllowAll: false,
                                    }"
                                    :search-options="{
                                        enabled: false,
                                        placeholder: 'Search Asset',
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :sort-options="{
                                        enabled: true,
                                    }">
                                    <div slot="emptystate">
                                        No Data Found.
                                    </div>
                                    <!-- <template slot="table-row" slot-scope="props" v-for="(row1,key) in voucherrows">
                                        <div :key="key">
                                            <template v-if="props.column.field == 'action'">
                                                    <a href="javascript:void(0)" v-on:click.prevent="grossVoucher(props.row.bill_id,props.row.total,'one')" class="color-blue underline" id="fullAPMap">
                                                        Full
                                                    </a>
                                            </template>
                                            <template v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </template>
                                        </div>
                                    </template> -->

                                </vue-good-table>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import moment from 'moment'


export default {
  name: "GLBalances",
  
  metaInfo() {
      return {title: "GL Balance | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading:false,
    dateArr:[],
    processed_date:'',
    processed_date_error_msg:'',
    gl_account_id:'',
    account_error_msg:'',
    accountsArr:[],
    // deposit:0,
    // withdraw:0,
    // opening_balance:0,
    // closing:0,
    optionsDate: {
        format: 'MM/YYYY',
        useCurrent: true,
    },
    bankArr:{
        opening:'$0.00',
        closing:'$0.00',
    },
    glRows:[],
    glColumns:[
            {
                label: 'Source',
                field: 'source',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Source", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'DOC. NO.',
                field: 'document_number',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "DOC. NO.", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Entity',
                field: 'entity',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Entity", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
            {
                label: 'Description',
                field: 'description',
                filterable: true,
                sortable:true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
             {
                label: 'Amount',
                field: 'total',
                filterable: true,
                sortable:true,
                type:'number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                },
            },
        ],
        glTotalRec:0,
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'can_see_gl_inquiry') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
  },
  methods: {
    onSearchAccount(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'accounts', '');
        }
    },
    fetchBankSummary: function(){
        var self = this;
        var error = false;
        self.account_error_msg = '';
        self.processed_date_error_msg = '';
        if (self.gl_account_id == null || !self.gl_account_id.value){
            self.account_error_msg = 'GL Account Required';
            error = true;
        }
        if (self.processed_date == ''){
            self.processed_date_error_msg = 'Process Period Required';
            error = true;
        }
        if (error){
            return;
        }

        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/gl-balances",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                pr_date:self.processed_date,
                gl_account_id:self.gl_account_id.value
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.glRows = data.content.inv;
                    // if (self.glRows != undefined && self.glRows.length > 0){
                    //     self.glTotalRec = self.glRows.length;
                    // }
                    self.bankArr = {
                        opening:data.opening,
                        closing:data.closing
                    }
                }else{
                    self.bankArr = {
                        opening:'$0.00',
                        closing:'$0.00',
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });
    },
  }
};
</script>
<style scoped>
.right-adjust{
    width: 50%!important;
    float: right;
    height: 38px;
    padding-right: 8px;
    border-bottom: 1px solid !important;
    border-bottom-color: #8080802e !important;
}
.overClass{
    overflow: visible !important;
}

.currencyinput input {
    border: 0;
}

</style>




// WEBPACK FOOTER //
// src/components/GLBalances.vue